import { render, staticRenderFns } from "./AdminCompaniesTable.vue?vue&type=template&id=68ccaa08&scoped=true"
import script from "./AdminCompaniesTable.vue?vue&type=script&lang=js"
export * from "./AdminCompaniesTable.vue?vue&type=script&lang=js"
import style0 from "./AdminCompaniesTable.vue?vue&type=style&index=0&id=68ccaa08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ccaa08",
  null
  
)

export default component.exports